<template>
    <div class="courses-single-page bg-dark-blue" style="overflow-y: auto;">
        <router-link class="nav-link" to="/">
            <div class="back-button" style="z-index: 1000;">
                <span>
                    Back
                </span>
            </div>
        </router-link>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="col-lg-12 course-single">
                        <div class="card mt-3 mb-3">
                            <div class="container-fluid">
                                <div class="content">
                                    <div class="d-flex align-items-center">
                                        <div class="title mr-4 ml-2 text-dark-blue">
                                            Payments
                                        </div>
                                        <div class="site-select mb-2" v-show="userRole == 'admin' && sites">
                                            <select v-model="selectedSite">
                                                <option v-for="site in sites" :value="site">{{site.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="table-responsive">

                                        <table class="table table-bordered" style="display: block;">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>ID</th>
                                                    <th>Created on</th>
                                                    <th>Completed on</th>
                                                    <th>User</th>
                                                    <th>Amount paid</th>
                                                    <th>Status</th>
                                                    <th>Payment method</th>
                                                    <th>Course names</th>
                                                    <th>Payment reference</th>
                                                    <th>Coupon names</th>
                                                    <th>Package names</th>
                                                </tr>
                                            </thead>
                                            <tbody style="overflow:scroll; max-height: 1000px;">
                                                <tr v-for="payment in filteredPayments">
                                                    <td>
                                                        <div v-if="payment.status == 'Approved'">
                                                            <button class="btn-info" @click="resendReceipt(payment.id)">Resend Receipt</button>
                                                        </div>
                                                    </td>
                                                    <td>{{ payment.id }}</td>
                                                    <td>{{ formatDate(payment.createdDate) }}</td>
                                                    <td>{{ formatDate(payment.completedDate) }}</td>
                                                    <td>{{ payment.userName.trim() == '()' ? 'No username' : payment.userName }}</td>
                                                    <td>{{ payment.amountPaid }}</td>
                                                    <td>{{ payment.status == null ? "No status" : payment.status }}</td>

                                                    <td>{{ payment.paymentMechanism }}</td>
                                                    <td>
                                                        <div v-for="courseName in payment.courseNames ">
                                                            {{ courseName }}
                                                        </div>
                                                    </td>
                                                    <td>{{ payment.paymentReference }}</td>
                                                    <td>
                                                        <div v-for="couponName in payment.couponNames ">
                                                            {{ couponName }}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div v-for="packageName in payment.packageNames ">
                                                            {{ packageName }}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-show="filteredPayments.length < 1">
                                                    <td colspan="12">No payments for selected site</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    .back-button{
        margin-right: 35px;
    }

    .table {
        font-size: 10px;
        text-align: center;
    }

    #upload-file-modal {
        top: 30% !important;
        display: block;
    }
</style>

<script>
    export default {
        name: 'AdminPayments',
        components: {


        },
        props: {

        },
        data() {
            return {
                payments: [],
                sites: null,
                selectedSite: null,
            }
        },
        computed: {
            userRole() {
                var roles = this.$store.state.user.roles;
                return roles[0];
            },
            userSiteId() {
                var id = this.$store.state.user.siteId;
                return id;
            },
            filteredPayments() {
                var filtered = [];

                if (this.userRole !== "author") {
                    for (var i = 0; i < this.payments.length; i++) {
                        var currentPayment = this.payments[i];
                        if (currentPayment.siteId == this.selectedSite.id) {
                            filtered.push(currentPayment);
                        }
                    }
                }
                else {
                    filtered = this.payments;
                }
                return filtered;
            }
        },
        methods: {
            async resendReceipt(transactionId) {
                await this.web('/Cart/ResendReceipt', "Resending Receipt for transaction: " + transactionId, {
                    id: transactionId
                });
            },
            formatDate(date) {
                if (date) {
                    var splitArr = date.split("T");
                    var cleanDate = splitArr[0];
                    return `${cleanDate}`
                }
                return date;
            }
        },
        async mounted() {
            if (this.userRole == "admin") {
                this.sites = await this.web('/sites', "Loading sites");
                this.selectedSite = this.sites[0];
            }

            this.payments = await this.web("/payments", "Loading payments");
            var crumbs = {};
            crumbs["/admin/payments"] = "Payments";
            this.$store.commit("breadCrumbs", crumbs);
        }
    }
</script>
